import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from '../../api/axios';
import { isNumeric } from "../../helpers/utils";
import styles from './Admin.module.css';
import LoadingModal from "../LoadingModal";
import { Link } from "react-router-dom";


const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditNumericQuestion = () => {

	const navigate = useNavigate();

	let { questionId } = useParams();

	const [text, setText] = useState("");
	const [type, setType] = useState("number");
	const [status, setStatus] = useState("active");
	const [minValue, setMinValue] = useState(0);
	const [maxValue, setMaxValue] = useState(999);
	const [decimalPlaces, setDecimalPlaces] = useState(0);
	const [feature, setFeature] = useState(true);
	const [priority, setPriority] = useState(1);
	const [chartType, setChartType] = useState(1);
	const [indicatorType, setIndicatorType] = useState(6);
	const [items, setItems] = useState("");

	const [textCopy, setTextCopy] = useState("");
	const [typeCopy, setTypeCopy] = useState("number");
	const [statusCopy, setStatusCopy] = useState("active");
	const [minValueCopy, setMinValueCopy] = useState(0);
	const [maxValueCopy, setMaxValueCopy] = useState(999);
	const [decimalPlacesCopy, setDecimalPlacesCopy] = useState(0);
	const [featureCopy, setFeatureCopy] = useState(true);
	const [priorityCopy, setPriorityCopy] = useState(1);
	const [chartTypeCopy, setChartTypeCopy] = useState(1);
	const [indicatorTypeCopy, setIndicatorTypeCopy] = useState(6);
	const [itemsCopy, setItemsCopy] = useState("");

	const [canSave, setCanSave] = useState(false);

	const [isSaving, setIsSaving] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(questionId ? false : true);

	const saveChanges = () => {
		if (questionId === undefined) {
			saveNewQuestion();
		} else {
			saveUpdatedQuestion();
		}
	}

	const saveNewQuestion = async () => {
		if (!canSave) {
			return;
		}

		const json = {};

		json.text = text;
		json.type = type;
		json.status = status;
		json.minValue = minValue;
		json.maxValue = maxValue;
		json.decimalPlaces = decimalPlaces;
		json.feature = feature;
		json.priority = priority;
		json.chartType = chartType;
		json.indicatorType = indicatorType;
		if (items !== "") {
			json.items = items;
		}

		setIsSaving(true);

		try {
			const response = await axios.post(`/numericQuestions`,
				JSON.stringify(json),
				{
					headers: { 'Content-Type': 'application/json' }
				}
			);

			console.log(response.data);

			questionId = response.data.questionId;

			parseResponse(response);

			navigate(`/numericquestion/edit/${questionId}`, { replace: true });

		} catch (err) {
			console.log(err);
			// if (!err?.response) {
			//     setErrMsg('No Server Response');
			// } else if (err.response?.status === 409) {
			//     setErrMsg('Email Taken');
			// } else {
			//     setErrMsg('Registration Failed')
			// }
			// errRef.current.focus();
		}

	}


	const saveUpdatedQuestion = async () => {
		if (!canSave) {
			return;
		}

		const json = {};

		json.text = text;
		json.type = type;
		json.status = status;
		json.minValue = minValue;
		json.maxValue = maxValue;
		json.decimalPlaces = decimalPlaces;
		json.feature = feature;
		json.priority = priority;
		json.chartType = chartType;
		json.indicatorType = indicatorType;
		if (items !== "") {
			json.items = items;
		}
		console.log(json);

		setIsSaving(true);

		try {
			const response = await axios.put(`/numericQuestions/${questionId}`,
				JSON.stringify(json),
				{
					headers: { 'Content-Type': 'application/json' }
				}
			);

			parseResponse(response);

		} catch (err) {
			console.log(err);
			// if (!err?.response) {
			//     setErrMsg('No Server Response');
			// } else if (err.response?.status === 409) {
			//     setErrMsg('Email Taken');
			// } else {
			//     setErrMsg('Registration Failed')
			// }
			// errRef.current.focus();
		}

	}

	const parseResponse = (response) => {
		if (response && response.data) {

			console.log(JSON.stringify(response.data));

			setText(response.data.text);
			setType(response.data.type);
			setStatus(response.data.status);
			setMinValue(response.data.minValue);
			setMaxValue(response.data.maxValue);
			setDecimalPlaces(response.data.decimalPlaces);
			setFeature(response.data.feature);
			setPriority(response.data.priority);
			setChartType(response.data.chartType);
			setIndicatorType(response.data.indicatorType);
			setItems(((response.data.items === undefined) || (response.data.items === null)) ? "" : response.data.items);

			setTextCopy(response.data.text);
			setTypeCopy(response.data.type);
			setStatusCopy(response.data.status);
			setMinValueCopy(response.data.minValue);
			setMaxValueCopy(response.data.maxValue);
			setDecimalPlacesCopy(response.data.decimalPlaces);
			setFeatureCopy(response.data.feature);
			setPriorityCopy(response.data.priority);
			setChartTypeCopy(response.data.chartType);
			setIndicatorTypeCopy(response.data.indicatorType);
			setItemsCopy(((response.data.items === undefined) || (response.data.items === null)) ? "" : response.data.items);

			setIsSaving(false);
			setDataLoaded(true);
		} else {
			console.log("Error: response is not valid");
		}

	}

	useEffect(() => {

		if (questionId === undefined) {
			return;
		}

		let isMounted = true;

		const controller = new AbortController();

		const getNumericQuestion = async () => {

			setIsSaving(true);

			try {
				const response = await axios.get(`/numericQuestions/${questionId}`, {
					signal: controller.signal
				});
				if (isMounted) {
					parseResponse(response);
				}
			} catch (err) {
				if (isMounted) {
					console.error(err);
					// if (err.response?.status === 403) {
					//     navigate('/login', { state: { from: location }, replace: true });
					// }
				}
			}
		}

		getNumericQuestion();

		return () => {
			isMounted = false;
			controller.abort();
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		let
			valid = true;

		if (!validTextRegex.test(text)) {
			valid = false;
		}
		if (!isNumeric(minValue)) {
			valid = false;
		}
		if (!isNumeric(maxValue)) {
			valid = false;
		}

		const changed =
			(text !== textCopy) ||
			(type !== typeCopy) ||
			(status !== statusCopy) ||
			(minValue !== minValueCopy) ||
			(maxValue !== maxValueCopy) ||
			(feature !== featureCopy) ||
			(priority !== priorityCopy) ||
			(chartType !== chartTypeCopy) ||
			(indicatorType !== indicatorTypeCopy) ||
			(items !== itemsCopy) ||
			(decimalPlaces !== decimalPlacesCopy);

		setCanSave(valid && changed);

	}, [text, type, status, minValue, maxValue, decimalPlaces, feature, priority, chartType, indicatorType, items, textCopy, typeCopy, statusCopy, minValueCopy, maxValueCopy, decimalPlacesCopy, featureCopy, priorityCopy, chartTypeCopy, indicatorTypeCopy, itemsCopy]);

	if (!dataLoaded) {
		return <LoadingModal />;
	}

	console.log(`EditNumericQuestion: render at ${new Date().getTime()}`);

	return (
		<section className={styles.admin}>

			<p><Link to="/admin">Admin</Link> &gt; <Link to="/questions">Questions</Link></p>

			<h3 className={styles.noBorder}>{(questionId === undefined) ? "New numeric" : "Numeric"} question</h3>

			<input type="text" name="question" autoComplete="off" autoFocus={true} maxLength="500" placeholder="How old are you?" value={text} onChange={e => setText(e.target.value)} />

			<h3>Type:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="number" name="type" value="number" onChange={(e) => setType(e.target.value)} checked={type === "number"} />
				<label htmlFor="number">Number</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="currency" name="type" value="currency" onChange={(e) => setType(e.target.value)} checked={type === "currency"} />
				<label htmlFor="currency">Currency</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="percent" name="type" value="percent" onChange={(e) => setType(e.target.value)} checked={type === "percent"} />
				<label htmlFor="percent">Percent</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="items" name="type" value="items" onChange={(e) => setType(e.target.value)} checked={type === "items"} />
				<label htmlFor="items">Items</label>
			</div>

			<label className={type !== "items" ? "disabled" : null}>Items:</label>
			<select name="items" value={items} onChange={(e) => setItems(e.target.value)} disabled={type !== "items"} >
				<option value=""></option>
				<option value="years">years</option>
				<option value="months">months</option>
				<option value="weeks">weeks</option>
				<option value="days">days</option>
				<option value="hours">hours</option>
				<option value="clients">clients</option>
				<option value="people">people</option>
			</select>



			<h3>Status:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="active" name="status" value="active" onChange={(e) => setStatus(e.target.value)} checked={status === "active"} />
				<label htmlFor="active">Active</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="archived" name="status" value="archived" onChange={(e) => setStatus(e.target.value)} checked={status === "archived"} />
				<label htmlFor="archived">Archived</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="deleted" name="status" value="deleted" onChange={(e) => setStatus(e.target.value)} checked={status === "deleted"} />
				<label htmlFor="deleted">Deleted</label>
			</div>

			<label htmlFor="minValue">Minimum value:</label>
			<input
				type="number"
				id="minValue"
				name="minValue"
				required
				min="0"
				max="999999999"
				inputMode="decimal"
				pattern="\d*"
				autoComplete="off"
				value={minValue}
				onChange={(e) => setMinValue(e.target.value)}
			/>

			<label htmlFor="maxValue">Maximum value:</label>
			<input
				type="number"
				id="maxValue"
				name="maxValue"
				required
				min="0"
				max="999999999"
				inputMode="decimal"
				pattern="\d*"
				autoComplete="off"
				value={maxValue}
				onChange={(e) => setMaxValue(e.target.value)}
			/>

			<label htmlFor="decimalPlaces">Decimal places:</label>
			<select name="decimalPlaces" value={decimalPlaces} onChange={(e) => setDecimalPlaces(parseInt(e.target.value, 10))}>
				<option value="0">0</option>
				<option value="1">1</option>
				<option value="2">2</option>
			</select>

			{/* <label htmlFor="priority">Priority (5: highest, 1: lowest)</label>
            <select name="priority" value={priority} onChange={(e) => setPriority(parseInt(e.target.value, 10))}>
                <option value="5">5 (Highest)</option>
                <option value="4">4 (High)</option>
                <option value="3">3 (Moderate)</option>
                <option value="2">2 (Low)</option>
                <option value="1">1 (Lowest)</option>
            </select> */}

			<label htmlFor="chartType">Chart type:</label>
			<select name="chartType" value={chartType} onChange={(e) => setChartType(e.target.value)}>
				<option value="gauge">Gauge</option>
				<option value="age crosstab">Age crosstab</option>
				<option value="gender crosstab">Gender crosstab</option>
				<option value="firm type crosstab">Firm-type crosstab</option>
				<option value="team crosstab">Team-type crosstab</option>
				<option value="AUM crosstab">AUM crosstab</option>
				<option value="tenure crosstab">Tenure crosstab</option>
				<option value="region crosstab">Region crosstab</option>
			</select>

			<label htmlFor="indicatorType">Gauge chart indicator:</label>
			<select name="indicatorType" value={indicatorType} onChange={(e) => setIndicatorType(e.target.value)} disabled={chartType !== "gauge"}>
				<option value="1st percentile">1st percentile</option>
				<option value="5th percentile">5th percentile</option>
				<option value="10th percentile">10th percentile</option>
				<option value="25th percentile">25th percentile</option>
				<option value="50th percentile">50th percentile</option>
				<option value="75th percentile">75th percentile</option>
				<option value="90th percentile">90th percentile</option>
				<option value="95th percentile">95th percentile</option>
				<option value="99th percentile">99th percentile</option>
			</select>

			{/* <div className="checkbox-and-label" style={{ marginTop: '1.5rem' }}>
                <input type="checkbox" id="feature" name="feature" onChange={(e) => setFeature(e.target.checked)} checked={feature} />
                <label htmlFor="feature">Feature this question on a dashboard</label>
            </div> */}

			<button disabled={!canSave || isSaving} onClick={saveChanges}>Save changes</button>

		</section>
	);

};

export default EditNumericQuestion;